import React from 'react';
import { useRound } from '../../Data/Rounds';
import { Link } from 'react-router-dom';
import Loading from '../Loading';
import { getEntityLink } from '../../Services/helpers';

const RoundName = ({ roundId }) => {
    const { round, isLoading } = useRound(roundId);

    if (isLoading || !round) {
        return <Loading inline />
    }

    return <Link to={getEntityLink('Rounds/Round', round.id)} className="link">
        {round.name}
    </Link>
}

export default RoundName;
